import { PropertyValue } from "./PropertyValue";

export class LookupPropertyValue extends PropertyValue {
    public Text: string;
}